import React from "react";

export function SettlementIcon(props) {
  const { height = "24", width = "24", color = "#EBEBEB" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 13.5c.433 0 .792-.142 1.075-.425.283-.283.425-.642.425-1.075 0-.433-.142-.792-.425-1.075-.283-.283-.642-.425-1.075-.425-.433 0-.792.142-1.075.425-.283.283-.425.642-.425 1.075 0 .433.142.792.425 1.075.283.283.642.425 1.075.425zM13 17c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 11 15V9c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 13 7h7c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 17h-7zm-8 4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5h-8c-1.183 0-2.146.37-2.887 1.112C9.37 6.854 9 7.817 9 9v6c0 1.183.37 2.146 1.113 2.887C10.854 18.63 11.817 19 13 19h8c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21H5z"
        fill={color}
      />
    </svg>
  );
}
